export default __webpack_public_path__ + "static/media/pirates_light.25095ae2.png";